export default "__VITE_ASSET__755d3d0f__"